import { type FieldResponseDTO } from '@capsicum/common';

import {
	CurrencyAmountField,
	DateField,
	DateTimeField,
	LinkField,
	TextField,
	TimeField
} from '../../ui/transaction-details';

export const valueMap = {
	// TODO: this type based on the response from the API, but the API is not ready yet
	amount: (props: { data: FieldResponseDTO['data']; isCopyable?: boolean }) => (
		<CurrencyAmountField
			amount={props.data?.amount as string}
			shortCode={props.data?.shortCode as string}
			{...props}
		/>
	),
	currencyAmount: (props: { data: FieldResponseDTO['data']; isCopyable?: boolean }) => (
		<CurrencyAmountField amount={props.data?.amount} shortCode={props.data?.shortCode ?? ''} {...props} />
	),
	date: (props: { data: FieldResponseDTO['data'] }) => (
		<DateField value={props.data?.dateTime as string} {...props} />
	),
	dateTime: (props: { data: FieldResponseDTO['data'] }) => (
		<DateTimeField value={props.data?.dateTime as string} {...props} />
	),
	link: (props: { data: FieldResponseDTO['data'] }) => <LinkField href={props.data?.value as string} {...props} />,
	text: (props: { data: FieldResponseDTO['data']; isCopyable?: boolean }) => (
		<TextField value={props.data?.value as string} {...props} />
	),
	time: (props: { data: FieldResponseDTO['data'] }) => <TimeField value={props.data?.dateTime as string} {...props} />
};
